import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=2b945b6c&"
import script from "./Store.vue?vue&type=script&lang=js&"
export * from "./Store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports